import WalletIntegrationEdit from './wallet-integration.edit';
import WalletIntegrationShow from './wallet-integration.show';
import WalletIntegrationList from './wallet-integration.list';

export default {
  edit: WalletIntegrationEdit,
  show: WalletIntegrationShow,
  list: WalletIntegrationList,
};
